<template>
	<main class="main-wrapper">
		<section class="main-container">
			<transition name="slide">
				<router-view></router-view>
			</transition>
		</section>
	</main>
</template>

<script>
export default {
	methods : {
		onCanStartToPlay() {
			if(!this.$refs.background) return;
			this.$refs.background.play();
		},
	}
};
</script>

<style lang="scss">
.main-wrapper {
	height : 100%;
	width : 100%;
	background : url('/assets/background_login.png');
	background-size : cover;
	background-repeat : no-repeat;
	background-position : center;
	position : relative;

	.main-container {
		width : 100%;
		height : 100%;
		position : absolute;
	}
}
</style>
